import React from "react";

export function BrandmarkSVG() {
  return (
    <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="17" fill="none" stroke="var(--brass)" strokeWidth="2" />
      <line x1="20" y1="6" x2="20" y2="12" stroke="var(--brass-bright)" strokeWidth="2" />
      <path d="M20 20 L27 12 L23 24 Z" fill="var(--coral)" />
      <path d="M20 20 L13 28 L17 16 Z" fill="var(--parchment)" />
    </svg>
  );
}

export function CompassSVG({ balance = 50, wobble = 0, leftLabel = "", rightLabel = "" }) {
  const angle = -55 + (balance / 100) * 110;
  const cx = 110, cy = 110, r = 92;
  const ticks = [];
  for (let i = 0; i < 24; i++) {
    const a = (i * 15) * Math.PI / 180;
    const len = i % 6 === 0 ? 12 : 6;
    const x1 = cx + Math.sin(a) * (r - 2);
    const y1 = cy - Math.cos(a) * (r - 2);
    const x2 = cx + Math.sin(a) * (r - 2 - len);
    const y2 = cy - Math.cos(a) * (r - 2 - len);
    ticks.push(
      <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="var(--brass)" strokeOpacity="0.5" strokeWidth="1.5" />
    );
  }
  const needleLen = r - 22;
  const a1 = angle * Math.PI / 180;
  const tipx = cx + Math.sin(a1) * needleLen;
  const tipy = cy - Math.cos(a1) * needleLen;
  const tailx = cx - Math.sin(a1) * (needleLen * 0.35);
  const taily = cy + Math.cos(a1) * (needleLen * 0.35);
  let wobbleLines = null;
  if (wobble > 8) {
    const a2 = (angle - wobble) * Math.PI / 180;
    const a3 = (angle + wobble) * Math.PI / 180;
    const t2x = cx + Math.sin(a2) * needleLen * 0.7;
    const t2y = cy - Math.cos(a2) * needleLen * 0.7;
    const t3x = cx + Math.sin(a3) * needleLen * 0.7;
    const t3y = cy - Math.cos(a3) * needleLen * 0.7;
    wobbleLines = (
      <>
        <line x1={cx} y1={cy} x2={t2x} y2={t2y} stroke="var(--coral)" strokeWidth="2" strokeDasharray="3,4" opacity="0.55" />
        <line x1={cx} y1={cy} x2={t3x} y2={t3y} stroke="var(--coral)" strokeWidth="2" strokeDasharray="3,4" opacity="0.55" />
      </>
    );
  }
  return (
    <svg viewBox="0 0 220 240" xmlns="http://www.w3.org/2000/svg">
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--brass)" strokeOpacity="0.35" strokeWidth="1.5" />
      <circle cx={cx} cy={cy} r={r - 14} fill="none" stroke="var(--brass)" strokeOpacity="0.18" strokeWidth="1" />
      {ticks}
      {wobbleLines}
      <line x1={tailx} y1={taily} x2={tipx} y2={tipy} stroke="var(--coral)" strokeWidth="3.5" strokeLinecap="round" style={{ transition: "all .35s ease" }} />
      <circle cx={cx} cy={cy} r="6" fill="var(--brass)" />
      <text x="110" y="16" textAnchor="middle" fill="var(--parchment)" fontFamily="IBM Plex Mono, monospace" fontSize="11">N</text>
      <text x="110" y="228" textAnchor="middle" fill="var(--white-soft)" fontFamily="Public Sans, sans-serif" fontSize="12" opacity="0.75">
        {leftLabel}  ·  {rightLabel}
      </text>
    </svg>
  );
}
